export default __webpack_public_path__ + "static/media/Idio.2d352cae.png";